import React, { useState } from "react";

import SMSBox from './SmsBox'
import Notification from "./notification/Notification";
import Banner from "./CustomizeBanner/Banner";
import BannerSample from "./BannerSample/BannerSample";
  
const SurveyHistory = () => {
  const [activeComponent, setActiveComponent] = useState("In-App Messages")
  // Array with tab names and corresponding components

  const tabs = [
    { name: "In-App Messages", component: <SMSBox /> },
    // { name: "Mail Box", component: <MailBox /> },
    { name: "App Notification ", component: <Notification /> },
    { name: "Customize Banner", component: <Banner /> },
    { name: "Banner Sample", component: <BannerSample /> },
  ];


  // Find the active tab and its component
  const renderComponent = () => {
    const activeTab = tabs.find(tab => tab.name === activeComponent);
    return activeTab ? activeTab.component : null;
  };


  const changeActiveComponent = (name)=>{
    setActiveComponent(name)
  }

  return (
    <div className="min-h-screen flex flex-col items-center p-6 pt-14">
      <div className="flex flex-col justify-center items-center w-full sticky top-14 bg-[var(--bgColor)]" style={{zIndex:1}}>
      <h1 className="text-xl m-4 font-semibold">Communication Channels</h1>
      <div className="flex space-x-4 mb-6 max-w-100">
        {tabs.map(({ name }) => (
          <button
            key={name}
            className={`px-4 py-2 rounded-lg text-sm border-b-2 ${
              activeComponent === name
                ? "activeBtn text-white"
                : "bg-neutral-50 text-gray-800 hover:bg-blue-100"
            }`}
            onClick={() => {changeActiveComponent(name)}}
          >
            {name}
          </button>
        ))}
      </div>
      </div>

      {renderComponent()}
    </div>
  );
};

export default SurveyHistory;
